module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAJCAYAAAAhFky8AAAA00lEQVR4Xr2TvQ3CQAyF36VmAAZggwyBKFgDxHWMwQKJYBB+ekpuAwZgAHqDrXuSZUVJg/ikp2c7ti6+KAkOEekA7AD0KaVca/gpPEjIsRVS65D74SzXvZiLrH3OmNJ8rB8KD4pegTbrHId8zphijXHMG7tGZfMASvp6Ube80oEsn8D7tcIQt4UJs/kFhDPEb2cSUJqHbRF9Yg6D3gDodRtTgWLOmj33nFq7BeLqKvaPMf0Nw0bd1Iaxx9cbKNzSEbbr+fZpW7LPGVOxpzrPyH//Dz9EI5Ju8dveNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_news.png
// module id = 524
// module chunks = 0